var index = {
  root: {
    fontSize: '0.875rem',
    fontWeight: '700',
    padding: '0.25rem 0.5rem',
    gap: '0.25rem',
    borderRadius: '{border.radius.sm}',
    roundedBorderRadius: '{border.radius.xl}',
  },
  icon: {
    size: '0.75rem',
  },
  colorScheme: {
    light: {
      primary: {
        background: '{primary.100}',
        color: '{primary.700}',
      },
      secondary: {
        background: '{surface.100}',
        color: '{surface.600}',
      },
      success: {
        background: '{interactiongreen.500}',
        color: '#ffffff',
      },
      info: {
        background: '{sky.100}',
        color: '{sky.700}',
      },
      warn: {
        background: '{signalorange.500}',
        color: '#ffffff',
      },
      danger: {
        background: '{signalred.500}',
        color: '#ffffff',
      },
      contrast: {
        background: '{surface.950}',
        color: '{surface.0}',
      },
    },
    dark: {
      primary: {
        background: 'color-mix(in srgb, {primary.500}, transparent 84%)',
        color: '{primary.300}',
      },
      success: {
        background: '{interactiongreen.500}',
        color: '#ffffff',
      },
      success: {
        background: '{interactiongreen.500}',
        color: '#ffffff',
      },
      info: {
        background: '{sky.100}',
        color: '{sky.700}',
      },
      warn: {
        background: '{signalorange.500}',
        color: '#ffffff',
      },
      danger: {
        background: '{signalred.500}',
        color: '#ffffff',
      },
      contrast: {
        background: '{surface.0}',
        color: '{surface.950}',
      },
    },
  },
};

export { index as default };
//# sourceMappingURL=index.mjs.map
